import { useApiService } from '../../dsha-api';
import { AutoEnrollmentService } from '../services/auto-enrollment-service';

export const useAutoEnrollmentService = () => useApiService(AutoEnrollmentService);
